export default __webpack_public_path__ + "static/media/admin.76c73353.svg";